import { IconClose } from '@ui/src';
import { useAppDispatch } from '@store';
import { setSelectedOrganizations } from '../../hoc/warning-report/store/slice';
import WarningsReportFilter from './filter';
import { WarningsReportFiltersTypes } from './types';

import cn from './styles.module.css';

const WarningsReportFilters = ({
  filters,
  onFilter,
  onSearch,
  autocompleteList,
  selectedOrganizations,
  organizationIsLoading,
  organizationSearchText,
  setOrganizationSearchText,
  wrapperRef,
  onScroll,
  nextPageIsLoading,
  transactionTypes,
  paymentTypes,
  customersFilters,
  listFilters,
}: WarningsReportFiltersTypes) => {
  const dispatch = useAppDispatch();

  return (
    <>
      {!listFilters && (
        <WarningsReportFilter
          filters={filters}
          setFilters={onFilter}
          name="date"
          title="Date"
          type="date"
        />
      )}

      {!customersFilters && !listFilters && (
        <WarningsReportFilter
          filters={filters}
          setFilters={onFilter}
          name="organizationId"
          title="Customer"
          type="select"
          onSearch={onSearch}
          list={autocompleteList}
          selectedValues={selectedOrganizations}
          setSelectedValues={(data) => dispatch(setSelectedOrganizations(data))}
          listLoading={organizationIsLoading}
          listSearchText={organizationSearchText}
          setListSearch={setOrganizationSearchText}
          wrapperRef={wrapperRef}
          onScroll={onScroll}
          nextPageIsLoading={nextPageIsLoading}
        />
      )}
      <WarningsReportFilter
        filters={filters}
        setFilters={onFilter}
        name="organizationType"
        title="Customer type"
        type="checkbox"
        list={[
          { value: 'CORPORATE', name: 'Corporate' },
          { value: 'INDIVIDUAL', name: 'Individual' },
          { value: 'COMPANY_OFFICIAL', name: 'Company Official' },
        ]}
      />
      <WarningsReportFilter
        filters={filters}
        setFilters={onFilter}
        name="transactionTypeId"
        title="Transaction type"
        type="checkbox"
        list={transactionTypes}
      />
      <WarningsReportFilter
        filters={filters}
        setFilters={onFilter}
        name="transactionPaymentType"
        title="Transaction payment type"
        type="checkbox"
        list={paymentTypes}
      />
      <WarningsReportFilter
        filters={filters}
        setFilters={onFilter}
        name="paymentOrderType"
        title="Payment order types"
        type="checkbox"
        list={[
          {
            name: 'Cash Collection Sinlge Output',
            value: 'CASH_COLLECTION_SINGLE_OUTPUT',
          },
          {
            name: 'Cash Collection Multiple Output',
            value: 'CASH_COLLECTION_MULTIPLE_OUTPUT',
          },
          {
            name: 'Batch Import Incoming Transactions',
            value: 'BATCH_IMPORT_INCOMING_TRANSACTIONS',
          },
        ]}
      />
      {!listFilters && (
        <WarningsReportFilter
          filters={filters}
          setFilters={onFilter}
          name="actions"
          title="Action"
          type="checkbox"
          list={[
            {
              name: 'Stop',
              value: 'STOP',
            },
            {
              name: 'Pass Once',
              value: 'PASS_ONCE',
            },
            {
              name: 'Pass Combination',
              value: 'PASS_COMBINATION',
            },
            {
              name: 'Pass all time for this client',
              value: 'PASS_ALL_TIME_FOR_THIS_CLIENT',
            },
            {
              name: 'RFI to client docs',
              value: 'RFI_TO_CLIENT_DOCS',
            },
            {
              name: 'RFI to client clarifications',
              value: 'RFI_TO_CLIENT_CLARIFICATIONS',
            },
          ]}
        />
      )}

      {(filters?.date?.length ||
        filters?.organizationType?.length ||
        filters?.organizationId?.length ||
        filters?.paymentOrderType?.length ||
        filters?.transactionPaymentType?.length ||
        filters?.actions?.length ||
        filters?.transactionTypeId?.length) && (
        <div className={cn.clearButtonWrapper}>
          <button
            type="button"
            className={cn.clearFilterButton}
            onClick={() =>
              onFilter({
                date: undefined,
                organizationId: undefined,
                organizationType: undefined,
                transactionTypeId: undefined,
                transactionPaymentType: undefined,
                paymentOrderType: undefined,
                actions: undefined,
              })
            }
          >
            Clear All <IconClose width={14} height={14} />
          </button>
        </div>
      )}
    </>
  );
};

export default WarningsReportFilters;
